import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Growth } from '@/components/analytics/common/Growth.jsx';
import { NoDataPlaceholder } from '@/components/analytics/common/NoDataPlaceholder.jsx';

const StyledValueContainer = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
}));

const StyledValueTypography = styled(Typography)(() => ({
    fontWeight: 'bold',
}));

export const AnalyticsChartTitle = ({ title, value, growth, hideNoDataPlaceholder }) => {
    const formatNumber = num => {
        if (!num && num !== 0) return '';
        return num.toLocaleString('pl-PL', { maximumFractionDigits: 0 }).replace(/\s/g, '.');
    };

    const formattedValue = formatNumber(value);

    return (
        <Box>
            <Typography variant='h6'>{title}</Typography>
            <StyledValueContainer>
                {value || !hideNoDataPlaceholder ? (
                    <>
                        <StyledValueTypography variant='h3' component='h3'>
                            {formattedValue}
                        </StyledValueTypography>
                        <Growth value={growth} />
                    </>
                ) : (
                    <NoDataPlaceholder width='125px' height='36px' />
                )}
            </StyledValueContainer>
        </Box>
    );
};
